import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import SectionHeader from "../../../util/component/SectionHeader";
import CustomerBaseSearch from "../component/CustomerBaseSearch";
import CustomerBaseTable from "../component/CustomerBaseTable";

const CustomerBaseList = () => {
    const {t} = useTranslation(['customerbase', 'translation']);
    return (
        <Box>
            <SectionHeader title={t('headers.customerbaseSearchTitle')}/>
            <Box p={useTheme().spacing(2)}>
                <CustomerBaseSearch activePartnerType="all"/>
                <CustomerBaseTable activePartnerType="all"/>
            </Box>
        </Box>
    )
}

export default CustomerBaseList;